import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  reduxForm,
  formValueSelector,
  getFormSyncErrors,
  getFormValues,
} from 'redux-form';
import { registerUser } from '../../redux/actions';
import { gtagEvent } from '../../common/lib/analyticsEventManager';

import RegisterForm from './RegisterForm';
import {
  focusValidationSummaryById,
  scrollToFirstErrorField,
  VALIDATION_SUMMARY_TO_FIELD_DELAY_MS,
} from '../../common/lib/scrollToFirstErrorField';
import { clearTimeoutRef, setComponentTimeout } from '../../common/lib/setComponentTimeout';

const formName = 'register';

const formSelector = formValueSelector(formName);

import '../../../style/index.css';
import './register.css';

const mapStateToProps = (state) => ({
  password: formSelector(state, 'password'),
  email: formSelector(state, 'email'),
  formErrors: getFormSyncErrors(formName)(state),
  registerFormValues: getFormValues(formName)(state),
  isFetching: state.registerReducer.isFetching,
  registrationFailed: state.registerReducer.registrationFailed,
  errorDetail: state.registerReducer.errorDetail,
  statusCode: state.registerReducer.statusCode,
  duplicatedEmail: state.registerReducer.duplicatedEmail,
});

const mapDispatchToProps = {registerUser};

@connect(mapStateToProps, mapDispatchToProps)
class RegisterView extends Component {
  static propTypes = {
    password: PropTypes.string,
    email: PropTypes.string,
    valid: PropTypes.bool,
    touch: PropTypes.func,
    formErrors: PropTypes.object,
    registerUser: PropTypes.func,
    history: PropTypes.object,
    registerFormValues: PropTypes.object,
    isFetching: PropTypes.bool,
    registrationFailed: PropTypes.bool,
    errorDetail: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    statusCode: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    duplicatedEmail: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.handleRegisterSubmit = this.handleRegisterSubmit.bind(this);
    this.formRef = React.createRef();
    this.timeoutRef = React.createRef();
    this.state = {
      formSubmissionError: false,
      isSubmitting: false, 
    };
  }

  componentDidMount() {
    gtagEvent('DC-5139115/colle0/colle00-+standard');
  }

  componentWillUnmount() {
    clearTimeoutRef(this.timeoutRef);
  }

  componentDidUpdate(prevProps) {
    const {
      registrationFailed, errorDetail, isFetching, 
    } = this.props;
    if (prevProps.isFetching && !isFetching && this.state.isSubmitting) {
      this.setState({ isSubmitting: false });
    }
    if (
      registrationFailed
      && errorDetail
      && (!prevProps.registrationFailed || prevProps.errorDetail !== errorDetail)
    ) {
      focusValidationSummaryById('register-api-error');
    }
  }

  handleRegisterSubmit(e) {
    e.preventDefault();
    const {
      valid,
      touch,
      formErrors,
      registerUser,
      history,
      registerFormValues,
      isFetching,
    } = this.props;

    if (isFetching || this.state.isSubmitting) {
      return;
    }

    if (valid) {
      gtagEvent('DC-5139115/nylot0/nylre0+standard');
      this.setState({
        formSubmissionError: false,
        isSubmitting: true, 
      });
      registerUser(registerFormValues, {}, history.push);
    } else {
      touch(...Object.keys(formErrors));
      this.setState({ formSubmissionError: true }, () => {
        focusValidationSummaryById('register-validation-summary');
        setComponentTimeout(this.timeoutRef, () => {
          scrollToFirstErrorField(formErrors, this.formRef);
        }, VALIDATION_SUMMARY_TO_FIELD_DELAY_MS);
      });
    }
  }

  render() {
    const {
      password,
      email,
      location,
      isFetching,
      registrationFailed,
      errorDetail,
      statusCode,
    } = this.props;
    const { formSubmissionError, isSubmitting } = this.state;

    return (
      <div
        key={location.pathname}
        className="register row justify-content-center"
      >
        <div className="col-xl-7 col-lg-8 col-md-8 col-sm-10 ">
          <RegisterForm
            formRef={this.formRef}
            password={password}
            email={email}
            submitFormFn={this.handleRegisterSubmit}
            formSubmissionError={formSubmissionError}
            isFetching={isFetching || isSubmitting}
            registrationFailed={registrationFailed}
            errorDetail={errorDetail}
            statusCode={statusCode}
          />
        </div>
      </div>
    );
  }
}

export default reduxForm({ form: formName })(RegisterView);
